<template>
  <div
    :class="$style.root"
    ref="rootElement"
    @keydown.esc="closeSelf"
    tabindex="0"
    :data-mounted="mounted ? '' : null"
  >
    <div
      :class="$style.content"
      ref="contentElement"
    >
      <div :class="$style.heading">
        <button
          :class="$style.button"
          @click="closeSelf()"
        >
          <SvgoCross data-cross />
        </button>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
const localePath = useLocalePath()

const props = defineProps({
  parentRoute: {
    type: [String, Object],
    default: true,
  }
})

const rootElement = ref(null)
const contentElement = ref(null)
const router = useRouter()

const closeSelf = () => {
  router?.push(localePath(props?.parentRoute))
}

onClickOutside(contentElement, () => {
  closeSelf()
})


const mounted = ref(false)
onMounted(() => {
  setTimeout(() => {
    document.documentElement.toggleAttribute('data-overflow-hidden', true)
    rootElement.value.focus()
    mounted.value = true
  }, 50)
})

onBeforeUnmount(() => {
  if (process.client) {
    document.documentElement.removeAttribute('data-overflow-hidden', '')
  }
})

onBeforeRouteLeave((to, from, next) => {
  mounted.value = false
  setTimeout(() => {
    next()
  }, 350)
})
</script>

<style module lang=scss>
.root {
  position: fixed;
  z-index: var(--z-index--modal);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: scroll;

  transition: backdrop-filter var(--transition--default);
}

.root[data-mounted] {
  backdrop-filter: grayscale(25%) invert(25%);
}

.root:focus {
  outline: none;
}

.content {
  width: 50vw;

  color: var(--color--primary, var(--color--black));
  background-color: var(--color--background, var(--color--white));

  padding: var(--unit--vertical) 0;
  padding-bottom: calc(var(--unit--vertical) * 2);

  display: flex;
  flex-direction: column;

  box-shadow: var(--box-shadow--default);

  @media (max-width: $breakpoint-m) {
    width: 75vw;
  }

  @media (max-width: $breakpoint-s) {
    width: 100vw;
  }

  min-height: 100%;

  transform: translateX(100%);
  transition: transform var(--transition--default);

  margin-left: auto;
}

.root[data-mounted] .content {
  transform: translateX(0%);
}

.heading {
  display: flex;
  justify-content: flex-end;
  padding: 0 var(--unit--horizontal);

  position: sticky;
  top: var(--unit--vertical);
  z-index: 1;
}

.button {
  composes: reset-button button-square from global;
}
</style>
